import React from 'react';

function CartPage({ cart, setCurrentPage, onRemove }) {
  const total = cart.reduce((sum, item) => sum + item.price, 0);

  return (
    <main className="cart-page">
      <h2>Your Cart</h2>
      {cart.length === 0 ? (
        <p>Your cart is empty</p>
      ) : (
        <>
          <div className="cart-items">
            {cart.map((item, idx) => (
              <div key={idx} className="cart-item">
                <div className="cart-item-info">
                  <p><strong>{item.name}</strong></p>
                  <p className="cart-price">₹{item.price}</p>
                </div>
                <button 
                  className="btn-delete" 
                  onClick={() => onRemove(idx)}
                  title="Remove from cart"
                >
                  🗑️ Delete
                </button>
              </div>
            ))}
          </div>
          <h3>Total: ₹{total}</h3>
          <button onClick={() => setCurrentPage('checkout')}>Proceed to Checkout</button>
        </>
      )}
    </main>
  );
}

export default CartPage;